import React from 'react'
import PropTypes from 'prop-types'
import { getNotificationContent } from '../content'
import { relativeTimeParts } from '../relativeTime'
import { resolveFactLabel, resolveFactSearchTerm } from './factLabel'
import ConflictPair from '../../../Shared/Factsheet/contradictions/ConflictPair'

const ContradictoryFactsDetail = ({ notification, blueprint, onReview, onFactSelect, t }) => {
  const { title, body } = getNotificationContent(notification, t)
  const time = relativeTimeParts(notification.createdAt)
  const pairs = notification.payload?.pairs ?? []

  // a fact is clickable only if we can turn it into a search term (blueprint
  // loaded and the id is known); otherwise fall back to a plain, static label.
  const toSide = (token) => {
    const clickable = onFactSelect && resolveFactSearchTerm(blueprint, token)
    return {
      label: resolveFactLabel(blueprint, token),
      onClick: clickable ? () => onFactSelect(token) : undefined,
    }
  }

  return (
    <React.Fragment>
      <div className="NotificationDetail-Category">
        {t('notificationCenter.types.contradictoryFacts.category')}
      </div>
      <div className="NotificationDetail-Summary">
        <p className="NotificationDetail-Summary-Title">{title}</p>
        <p className="NotificationDetail-Summary-Time">{t(time.key, time.options)}</p>
      </div>
      {body && <p className="NotificationDetail-Description">{body}</p>}
      <div className="NotificationDetail-ConflictList">
        {pairs.map((pair, index) => (
          <ConflictPair
            key={`${pair.left}-${pair.right}-${index}`}
            compact
            left={toSide(pair.left)}
            right={toSide(pair.right)}
          />
        ))}
      </div>
      <button type="button" className="NotificationDetail-ReviewButton" onClick={onReview}>
        {t('notificationCenter.types.contradictoryFacts.reviewAction')}
      </button>
    </React.Fragment>
  )
}

ContradictoryFactsDetail.propTypes = {
  notification: PropTypes.object.isRequired,
  blueprint: PropTypes.object,
  onReview: PropTypes.func.isRequired,
  onFactSelect: PropTypes.func,
  t: PropTypes.func.isRequired,
}

export default ContradictoryFactsDetail
